exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-primary {\n    color: #FFFFFF !important;\n}\n.bg-primary i.mdi-pencil {\n    color: #FFFFFF !important;\n}\n.vue_select {\n    width: 250px !important;\n}\n.vue_select > .text {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n", ""]);

// exports
